import styled from "styled-components";

const Container = styled.div`
  box-sizing: border-box;
  width: 100%;
`;

const Content = styled.div`
  box-sizing: border-box;
`;

const ChartWrapper = styled.div`
  box-sizing: border-box;
  position: relative;
`;

const Empty = styled.div`
  ${props => props.theme.font.caption}
  height: 278px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Tooltip = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${props => props.theme.spacing.S_10};
  background-color: ${props => props.theme.colors.white};
  border-radius: 8px;
  border: 1px solid ${props => props.theme.colors.redesign.db20};
`;

const GoalRect = styled.rect`
  fill: ${props => props.theme.colors.graph.goal};
  height: 22px;
  rx: 4px;
`;

const GoalText = styled.text`
  fill: ${props => props.theme.colors.white};
  text-anchor: end;
`;

export { Container, Content, ChartWrapper, Empty, Tooltip, GoalRect, GoalText };
